/**
 * Clients Page - Client Management (Placeholder)
 */
import React from 'react';
import { Users } from 'lucide-react';
import { Card } from '../components/ui-custom/ComplianceUI';

export default function ClientsPage() {
  return (
    <div className="placeholder-page">
      <div className="page-header">
        <h1>Client Management</h1>
        <p>Create and manage client organizations and users</p>
      </div>
      <Card className="empty-state">
        <Users size={48} color="#6b7280" />
        <h3>Coming Soon</h3>
        <p>Client management features will be available once client portal authentication is configured.</p>
      </Card>
    </div>
  );
}
